import {
    ADD_PROMPT_TO_QUEUE,
    REMOVE_PROMPT_FROM_QUEUE,
    CLEAR_PROMPT_QUEUE,
    RESET_PROMPT_QUEUE,
    INITIALIZE_PROMPT_QUEUE
} from '../../actions/promptQueueActions';
import { deleteFromArray } from '../../util/utils';

const PromptQueueReducer = (state = [], action) => {
    Object.freeze(state);
    let newState = Array.from(state);

    switch (action.type) {
        case ADD_PROMPT_TO_QUEUE:
            // for dependentOnRoot prompts, some answers might have the same tag.
            // don't add same tag multiple times to prevent looping
            if (!newState.includes(action.promptId)) {
                newState.push(action.promptId);
            }
            return newState;

        case REMOVE_PROMPT_FROM_QUEUE:
            return deleteFromArray(newState, action.promptId);
        
        case CLEAR_PROMPT_QUEUE:
            return [];

        case RESET_PROMPT_QUEUE:
            return [newState[0]];

        case INITIALIZE_PROMPT_QUEUE:
            return configurePromptQueue(action);

        default:
            return state;
    }
};

const configurePromptQueue = (action) => {
    const { assessment, prompts } = action;

    if (assessment.type === 'dependentOnRoot') {
        return [assessment.rootPrompt];
    }
    
    const promptIds = Object.keys(prompts);
    return promptIds;
}

export default PromptQueueReducer;